module.exports = __webpack_public_path__ + "img/logo_Ahex_predel.656e5dbc.png";